





























import Vue from "vue";

import { PropsIsImagePb } from "../../models/chat";

import JzChatImgDialog from "./JzChatImgDialog.vue";
import JzContainer from "../layout/JzContainer.vue";
import JzButton from "../control/JzButton.vue";
import JzTimerBar from "../feedback/JzTimerBar.vue";

import IconClose from "../../assets/icons/black/Close.svg";

type Props = PropsIsImagePb;

interface State {
  isStarted: boolean;
  isTimeout: boolean;
}

interface Methods {
  // Start to view
  start: () => void;
  // Close the dialog
  close: () => void;
  // Finished! No more time!
  timeout: () => void;
}

/**
 * decreaseTimer period is far from being optimized but easier to read
 *
 * @emit started
 * @emit closed
 * @emit timeout
 */
export default Vue.extend<State, Methods, {}, Props>({
  components: { JzButton, JzChatImgDialog, JzContainer, JzTimerBar },

  props: {
    seconds: { type: Number, required: true },
    imgUrl: { type: String, required: true },
    captions: { type: String, required: true },
    iconClose: { type: String, default: IconClose },
    textRemainingTime: { type: String, default: "残り時間" },
    textStart: { type: String, default: "スタート" }
  },

  data() {
    return {
      isStarted: false,
      isTimeout: false
    };
  },

  computed: {},

  methods: {
    start() {
      this.isStarted = true;
      (this.$refs.timer as any).start();
      this.$emit("started");
    },

    close() {
      this.$emit("closed");
    },

    timeout() {
      this.isTimeout = true;
      this.$forceUpdate();
      this.$emit("timeout");
    }
  }
});
